<template>
  <div>
    <div class="columns is-justify-content-space-between" v-if="!detail">
      <div class="column">
      </div>
      <div class="column is-narrow">
        <div class="button is-addOrEdit" @click="addFournisseur()">
          {{ $t('addEditMarche.addFournisseur.title') }}
        </div>
      </div>
    </div>
    <v-client-table v-model="marche.commissions" :columns="columns" :options="options"
                    ref="commissionsArray">
      <div slot="fournisseur" class="is-pulled-left width-100percent" slot-scope="props">
        <b-autocomplete v-if="!detail"
          v-model="props.row.fournisseur.nomCommercial"
          :data="fournisseurs"
          :loading="isFetchingFournisseur"
          :open-on-focus="false"
          @input="getFournisseur($event, props.index)"
          @select="setFournisseur($event, props.index)"
                        field="nomCommercial"
          icon="magnify">
          <template slot="header">
            <a @click="checkPermissions(permissionTiers.maj)
                  ? setPopUpNewFournisseur(props.index) : showPopUpPermission()">
              <a
                class="lien"
                :class="{ 'text-access-no-permission': !checkPermissions(permissionTiers.maj)}">
                <span> {{ $t('addEditMarche.addFournisseur.title') }}</span>
              </a>
            </a>
          </template>
          <template slot="empty">
            <div v-if="!isFetchingFournisseur">
              {{$t('general.autocomplete.noRslt')}}
            </div>
            <div v-else>
              {{$t('general.autocomplete.search')}}
            </div>
          </template>
        </b-autocomplete>
        <span v-else> {{ props.row.fournisseur.nomCommercial }}</span>
      </div>
      <div slot="pourcentage" slot-scope="props" class="is-pulled-left width-100percent">
        <b-input v-model="props.row.pourcentageRepartition" v-if="!detail"
                 @input="updateValue(props.index, 'pourcentageRepartition', $event)">
        </b-input>
        <span v-else> {{ props.row.pourcentageRepartition | formatPercent }}</span>
      </div>
      <div slot="delete" slot-scope="props">
        <a @click="deleteFournisseur(props.index)">
          <b-icon class="mgt-5px" icon="delete-forever" type="is-danger"></b-icon>
        </a>
      </div>
    </v-client-table>
    <b-modal v-if="marche.commissions[indexReference] !== undefined"
      v-model="isComponentAjoutClient"
      has-modal-card
      width="600px" class="modal">
      <creation-fournisseur
        @fournisseurId="marche.commissions[indexReference].fournisseurId = $event"
        :nom-fournisseur="marche.commissions[indexReference].fournisseur.nomCommercial"/>
    </b-modal>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import debounce from 'lodash/debounce';
import { getAll as getAllTiers } from '@/api/tiers';
import {
  TIERS_SOUS_TYPE_FOURNISSEUR_SUPPORT,
  TIERS_TYPE_FOURNISSEUR,
} from '@/configuration/tiers/tiersConf';
import messageErreur from '@/services/general/messageErreur';
import { columnsSplice } from '@/services/general/columns';
import { createNamespacedHelpers } from 'vuex';
import { TIERS } from '@/configuration/permissionsBodacConf';
import CreationFournisseur from '@/components/achat/marche/informations/creationFournisseur';

const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'listeFournisseur',
  props: {
    marche: {
      type: Object,
      required: true,
    },
    detail: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isFetchingFournisseur: false,
      fournisseurs: [],
      permissionTiers: TIERS,
      isComponentAjoutClient: false,
      indexReference: 0,
    };
  },
  components: {
    CreationFournisseur,
  },
  methods: {
    ...Permissions.mapActions({
      showPopUpPermission: 'showPopup',
    }),
    updateValue(index, variable, value) {
      this.marche.commissions[index - 1][variable] = value;
    },
    setFournisseur(newFournisseur, index) {
      if (!newFournisseur) return;
      this.marche.commissions[index - 1].fournisseur.nomCommercial = newFournisseur.nomCommercial;
      this.marche.commissions[index - 1].fournisseurId = newFournisseur.id;
    },
    deleteFournisseur(index) {
      this.marche.commissions.splice(index - 1, 1);
    },
    addFournisseur() {
      this.marche.commissions.push({
        fournisseur: {
          nomCommercial: '',
        },
        fournisseurId: null,
        pourcentageRepartition: 0,
      });
    },
    getFournisseur: debounce(async function fournisseurData(text, index) {
      if (text === this.marche.commissions[index - 1].fournisseur.nomCommercial) return;
      try {
        this.marche.commissions[index - 1].fournisseurId = null;
        this.marche.commissions[index - 1].fournisseur.nomCommercial = text;
        this.isFetchingFournisseur = true;
        this.fournisseurs = (await getAllTiers({
          query: {
            nomCommercial: text,
            type: TIERS_TYPE_FOURNISSEUR,
            societeId: this.societeActiveId,
            archive: false,
            sousType: [TIERS_SOUS_TYPE_FOURNISSEUR_SUPPORT],
          },
          limit: RESULTS_PER_PAGE,
        })).data.result.items;
        this.isFetchingFournisseur = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetchingFournisseur = false;
        throw e;
      }
    }),
    setPopUpNewFournisseur(index) {
      this.indexReference = index - 1;
      this.isComponentAjoutClient = true;
    },
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    columns() {
      const columns = ['fournisseur', 'pourcentage', 'delete'];
      if (this.detail) {
        columnsSplice(columns, 'delete');
      }
      return columns;
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          fournisseur: this.$t('addEditMarche.addFournisseur.fournisseur'),
          pourcentage: this.$t('addEditMarche.addFournisseur.pourcentage'),
          delete: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        columnsClasses: {
          delete: 'colonneSelected',
        },
        sortable: this.detail ? ['fournisseur', 'pourcentage'] : [],
      };
    },
  },
};
</script>

<style scoped>

</style>
